import styled from 'styled-components';
import { FetchCallableObjectErrors } from '../hooks/useFetchCallableObjectFromCallId';
import { EERIE, KOALA } from 'HubStyleTokens/colors';
import { WEB_FONT_MEDIUM_WEIGHT } from 'HubStyleTokens/misc';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
const Info = styled.div.withConfig({
  displayName: "ReturnCallPopoverError__Info",
  componentId: "y5t06f-0"
})(["padding:12px 16px;border-style:solid;border-width:2px 0 0 0;border-color:", ";font-weight:", ";color:", ";"], KOALA, WEB_FONT_MEDIUM_WEIGHT, EERIE);
const ReturnCallPopoverError = ({
  error
}) => {
  return error === FetchCallableObjectErrors.CALLABLE_OBJECT_NOT_FOUND ? /*#__PURE__*/_jsx(Info, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "call-highlight-card.returnCall.callableObjectNotFound"
    })
  }) : /*#__PURE__*/_jsx(UIAlert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "call-highlight-card.returnCall.error.title"
    }),
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "call-highlight-card.returnCall.error.message"
    })
  });
};
export default ReturnCallPopoverError;